import { isNonEmptyArray } from '../../../../utils/array-utils';
import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { salesDataDomainStore } from '../../store';
import { isNormalItem } from './item-type-utils';
/**
 * The current Item Picker UI does not handle nested views that will allow Recipe Item contents to be viewed and edited by the user.
 * If a Recipe Item has any customisable components then we will flag it as unsupported.
 */
export const isRecipeItemSupported = (item) => {
    return item.components.every(component => {
        if (component.isModifiable)
            return false;
        // TODO: Use getItemById when mapping for recipe items is removed. #291340
        const componentItem = getFetchedDataPayload(salesDataDomainStore.data.itemsById[component.itemId]);
        if (!componentItem)
            throw new Error(`Cannot find item with ID: '${component.itemId}'.`);
        if (!isNormalItem(componentItem))
            return false;
        if (isNonEmptyArray(componentItem.modifierGroups))
            return false;
        return true;
    });
};
